import { FC } from "react";
import { Application } from "Pages";
import { Box } from "@mui/material";
import { Route, Routes, Navigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { baseURL } from "Helpers";

const BoxStyled = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1),
  height: "100%",
  maxHeight: "100%",
  minHeight: "100%",
}));

export const App: FC = (props) => {
  return (
    <BoxStyled>
      <Routes>
        <Route path={baseURL} element={<Application />} />
        <Route path="/ViewEditRequests.aspx" element={<Navigate to={baseURL} />} />
      </Routes>
    </BoxStyled>
  );
};

export default App;